<template>
  <div class="hd-wap-integral">
    <!-- 如何获取积分说明-->
    <section class="infomation">
      <div class="content">
        <div class="title">
          <h1 class="f13">获取积分</h1>
          <p class="f10">学习课程,兑换书籍</p>
        </div>
        <div class="image">
          <img src="~assets/images/integral/icon_ruhehuodejifen_jifenshangcheng.png" alt="">
        </div>
      </div>
      <div class="text">
        积分是海渡职校诚挚回报学员的一种方式,是学员财富的象征。目前可使用积分兑换各类课程与实物书籍,均在对应课程栏目与积分商城功能模块下进行。后期我们将扩大积分的使用范围,敬请期待。
      </div>
    </section>
    <!-- 如何获取积分 -->
    <section class="method">
      <div class="title f13">如何获取积分?</div>
      <h3 class="title_x">新用户任务</h3>
      <div class="content">
        <div class="item">
          <p class="label">绑定手机<span class="f9">(首次)</span></p>
          <p class="number"><span>50</span>积分</p>
        </div>
        <div class="item">
          <p class="label">设置头像<span class="f9">(首次)</span></p>
          <p class="number"><span>50</span>积分</p>
        </div>
        <div class="item">
          <p class="label">补充资料</p>
          <p class="number"><span>100</span>积分</p>
        </div>
      </div>
      <h3 class="title_x">每日任务</h3>
       <div class="content">
        <div class="item">
          <p class="label">签到<span class="f9">(当日首次)</span></p>
          <p class="number"><span>10</span>积分</p>
        </div>
        <div class="item">
          <p class="label">课程分享<span class="f9">(每日上限3次)</span></p>
          <p class="number"><span>20</span>积分</p>
        </div>
        <div class="item">
          <p class="label">课程评论<span class="f9">(每日上限3次)</span></p>
          <p class="number"><span>20</span>积分</p>
        </div>
        <div class="item">
          <p class="label">圈子发布<span class="f9">(每日首次)</span></p>
          <p class="number"><span>20</span>积分</p>
        </div>
          <div class="item">
          <p class="label">圈子发布<span class="f9">(每日第二次)</span></p>
          <p class="number"><span>10</span>积分</p>
        </div>
        <div class="item">
          <p class="label">圈子发布<span class="f9">(每日第三次及以上)</span></p>
          <p class="number"><span>5</span>积分</p>
        </div>
        <div class="item">
          <p class="label">圈子评论<span class="f9">(每日上限5次)</span></p>
          <p class="number"><span>3</span>积分</p>
        </div>
        <div class="item">
          <p class="label">圈子点赞<span class="f9">(每日上限5次)</span></p>
          <p class="number"><span>2</span>积分</p>
        </div>
      </div>
      <h3 class="title_x">活动任务</h3>
      <div class="content">
        <div class="item">
          <p class="label">获取勋章<span class="f9"></span></p>
          <p class="number"><span>200</span>积分</p>
        </div>
        <div class="item">
          <p class="label">月度赛投票<span class="f9">(每日上限3次)</span></p>
          <p class="number"><span>10</span>积分</p>
        </div>
        <div class="item">
          <p class="label">邀请新用户</p>
          <p class="number"><span>400</span>积分</p>
        </div>
      </div>
    </section>
    <!-- 我的任务-->
    <section class="task">
      <div class="title">我的任务</div>
      <div class="tip">
        每天签到都有积分拿;积分获取在"<span>个人中心</span>"->"<span>我的任务</span>"中。
      </div>
      <div class="image">
        <img src="~assets/images/integral/img_jifenruhehuode.png" alt="">
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped lang="scss">
.hd-wap-integral {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f4f4f4;
}

.infomation {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: 0 0.4rem 0.467rem;
  .content {
    height: 3rem;
    background: url(~assets/images/integral/img_jifendi.png) center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    padding: 0 0.86rem;
    .title {
      color: #fff;
      margin-right: 1.6rem;
      h1 {
        margin-bottom: 0.267rem;
      }
    }
    .image {
      width: 2.267rem;
      img {
        width: 100%;
      }
    }
  }
  .text {
    color: #626b73;
    margin-top: 0.48rem;
    line-height: 2;
  }
}

.method {
  background: #fff;
  margin-top: 0.24rem;
  padding: 0.347rem 1.307rem 0.467rem;
  .title_x {
    text-align: center;
    margin: 0.4rem;
  }
  .title {
    width: 3.333rem;
    height: 0.667rem;
    line-height: 0.667rem;
    margin: 0 auto;
    background: url(~assets/images/integral/img_kuangkuang.png) center no-repeat;
    background-size: contain;
    text-align: center;
    padding-top: 0.08rem;
  }
  .content {
    margin-top: 0.2rem;
    width: 100%;
    .item {
      display: flex;
      height: 0.867rem;
      align-items: center;
      border-bottom: 1px solid #bbbbbb;
      color: #3a3f43;
      .label {
        width: 3.567rem;
        // text-align: center;
        span {
          margin-left: 0.16rem;
        }
      }
      .number {
        margin-left: auto;
        span {
          color: #ff8f66;
          margin-right: 0.16rem;
        }
      }
    }
  }
}

.task {
  width: 100%;
  background: #fff;
  margin-top: 0.24rem;
  padding: 0.333rem 0 0.733rem;
  .title {
    width: 3.333rem;
    height: 0.667rem;
    line-height: 0.667rem;
    margin: 0 auto;
    background: url(~assets/images/integral/img_kuangkuang.png) center no-repeat;
    background-size: cover;
    text-align: center;
    padding-top: 0.08rem;
  }
  .tip {
    padding: 0 0.4rem;
    margin-top: 0.6rem;
    color: #6a6b73;
    span {
      color: #0193e6;
    }
  }
  .image {
    width: 100%;
    margin-top: 0.267rem;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Integral.vue?ad22fe82